/** url → decoded HTMLImageElement (carousel <img> or a pinned Image). */
const pinnedByUrl = new Map();

function isUsableImage(el) {
  return !!(el && el.complete && el.naturalWidth > 0);
}

/** Keep a decoded cutout around so the collage-details preview can clone it. */
export function registerFeedImage(url, el) {
  if (!url || typeof url !== 'string' || !el) return;
  pinnedByUrl.set(url, el);
}

/** Decode-and-hold when we warm a URL without a DOM node (carousel preload). */
export function pinFeedImageUrl(url) {
  if (!url || typeof url !== 'string') return;
  const existing = pinnedByUrl.get(url);
  if (isUsableImage(existing)) return;
  const img = new Image();
  img.decoding = 'async';
  img.onload = () => registerFeedImage(url, img);
  img.src = url;
  pinnedByUrl.set(url, img);
}

export function getPinnedFeedImage(url) {
  const el = pinnedByUrl.get(url);
  return isUsableImage(el) ? el : null;
}

/** Prefer the pinned bitmap; if that missed, use the live carousel <img>. */
export function findDecodedFeedImage(url) {
  const pinned = getPinnedFeedImage(url);
  if (pinned) return pinned;
  if (typeof document === 'undefined' || !url) return null;
  const nodes = document.querySelectorAll('.wanted-ad-card img.final-partner-image');
  for (const img of nodes) {
    const live = img.currentSrc || img.src;
    if (live === url && isUsableImage(img)) return img;
  }
  return null;
}
